import { render, staticRenderFns } from "./CalendarioCupos.vue?vue&type=template&id=6d2d5277&"
import script from "./CalendarioCupos.vue?vue&type=script&lang=js&"
export * from "./CalendarioCupos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports